import { render } from "./MobileAccountNav.vue?vue&type=template&id=4df9fe6c"
import script from "./MobileAccountNav.vue?vue&type=script&lang=js"
export * from "./MobileAccountNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mobile/account_center/components/MobileAccountNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4df9fe6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4df9fe6c', __exports__)) {
    api.reload('4df9fe6c', __exports__)
  }
  
  module.hot.accept("./MobileAccountNav.vue?vue&type=template&id=4df9fe6c", () => {
    api.rerender('4df9fe6c', render)
  })

}


export default __exports__